import * as React from "react";

import { cn } from "@/utils/theme";

import { cva, type VariantProps } from "class-variance-authority";

const textAreaVariants = cva(
  "rounded-md border-[1px] border-neutral text-body-loud bg-neutral-object-accent-silent placeholder:text-body-quiet not-disabled:hover:border-neutral-loud focus-visible:hover:border-contextual-action focus-visible:outline-none focus-visible:outline-2 focus-visible:border-contextual-action disabled:bg-neutral-object-accent-silent disabled:text-on-disabled disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        lg: "px-3 py-2",
        md: "px-3 py-1.5",
        sm: "px-2 py-1.5",
        xs: "p-1",
      },
    },
    defaultVariants: {
      variant: "md",
    },
  },
);

function Textarea({
  className,
  variant,
  ...props
}: React.ComponentProps<"textarea"> & VariantProps<typeof textAreaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(textAreaVariants({ className, variant }))}
      {...props}
    />
  );
}

export { Textarea };
